const isValidUrl = urlCandidate => {
  try {
    /* eslint-disable-next-line no-new */
    new URL(urlCandidate);
    return true;
  } catch (_) {
    return false;
  }
};

export { isValidUrl };
